var map = {
	"./": "32bb",
	"./admin": "ce1a",
	"./admin.js": "ce1a",
	"./auth": "831c",
	"./auth.js": "831c",
	"./availability": "cabf",
	"./availability.js": "cabf",
	"./ehr": "4c62",
	"./ehr.js": "4c62",
	"./errors": "092f",
	"./errors.js": "092f",
	"./image": "042f",
	"./image.js": "042f",
	"./index": "32bb",
	"./index.js": "32bb",
	"./network": "cda2",
	"./network.js": "cda2",
	"./patient-review": "5bcc",
	"./patient-review.js": "5bcc",
	"./patients": "d561",
	"./patients.js": "d561",
	"./practice": "af2d",
	"./practice.js": "af2d",
	"./profile": "5eaf",
	"./profile.js": "5eaf",
	"./public": "1100",
	"./public.js": "1100",
	"./referrals": "78b1",
	"./referrals-pool": "44f0",
	"./referrals-pool.js": "44f0",
	"./referrals.js": "78b1",
	"./temporary-referrals": "1dbd",
	"./temporary-referrals.js": "1dbd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a24e";